import type { NavigationGuard } from 'vue-router'
import { useAccountStore } from '@/stores/account.ts'
import { routeNames } from '@/router/names.ts'
import { getAccessToken } from '@/helpers/auth.ts'
import { useSubAccountStore } from '@/stores/subAccount.ts'
import { routeNamesByDocumentCode } from '@/config/requiredDocumentsCodes.ts'

export const guestGuard: NavigationGuard = async (to, from, next) => {
    const accountStore = useAccountStore()
    const subAccountStore = useSubAccountStore()

    const token = getAccessToken()

    if (!token) {
        accountStore.logout(true)

        return next()
    }

    if (accountStore.accountData && subAccountStore.subAccountsOptions.length) {
        return next({
            name: routeNames.HOME_VIEW_NAME,
            params: {
                subAccountId: subAccountStore.subAccountsOptions[0]!.subaccountId,
            },
        })
    }

    const { isSuccess: isAccountDataLoadSuccess, documentToAccept: documentToAccept1 } =
        await accountStore.loadAccountData()
    const { isSuccess: isSubAccountsLoadSuccess, documentToAccept: documentToAccept2 } =
        await subAccountStore.loadSubAccountsOptions()

    if (documentToAccept1 || documentToAccept2) {
        const docToAccept = documentToAccept1 || documentToAccept2

        return next({
            name: routeNamesByDocumentCode[docToAccept!],
        })
    }

    if (isAccountDataLoadSuccess && isSubAccountsLoadSuccess) {
        return next({
            name: routeNames.HOME_VIEW_NAME,
            params: {
                subAccountId: subAccountStore.subAccountsOptions[0]!.subaccountId,
            },
        })
    }

    accountStore.logout(true)

    return next()
}
